import { Button, Icon, Intent, Popover, Position } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import { DateRange, DateRangePickerProps } from '@blueprintjs/datetime'
import React from 'react'
import UprightDateRangePicker from '../../UprightDateRangePicker'

const toDateOrNull = (value: Date | string | null | undefined): Date | null => (value ? new Date(value) : null)

interface DateRangeFilterProps {
  meta: Record<string, any>
  onMetaChange: Function
  metaKey: string
  dateRangeProps?: Omit<Partial<DateRangePickerProps>, 'onChange' | 'value'>
}

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({ meta, onMetaChange, metaKey, dateRangeProps = {} }) => {
  const v = meta[metaKey]
  const start = v && v[0]
  const end = v && v[1]
  const [isOpen, setIsOpen] = React.useState(false)
  const [draftRange, setDraftRange] = React.useState<DateRange>([null, null])

  const handleInteraction = (nextOpen: boolean) => {
    if (nextOpen) {
      setDraftRange([toDateOrNull(start), toDateOrNull(end)])
    }
    setIsOpen(nextOpen)
  }

  const handleChange = (range: DateRange) => {
    setDraftRange(range)

    if (range[0] && range[1]) {
      onMetaChange(metaKey, range, true)
      setIsOpen(false)
    } else if (!range[0] && !range[1]) {
      onMetaChange(metaKey, null, true)
      setIsOpen(false)
    }
  }

  return (
    <div className="bp5-button-group home-created-at-filter">
      <Popover
        isOpen={isOpen}
        onInteraction={handleInteraction}
        position={Position.BOTTOM}
        content={
          <div className="popover-content">
            <UprightDateRangePicker {...dateRangeProps} onChange={handleChange} value={draftRange} />
          </div>
        }
      >
        <Button icon={IconNames.CALENDAR} intent={start && end ? Intent.PRIMARY : undefined}>
          <Icon icon={IconNames.CARET_DOWN} />
        </Button>
      </Popover>
    </div>
  )
}

export default DateRangeFilter
